module.exports = __webpack_public_path__ + "img/gy_img11.7c751b1b.png";